var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMydataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3764 35.0107H12.4317C12.4317 35.0107 11.5065 35.1083 11.2138 33.305C10.9211 31.5017 10.5814 27.7505 10.5814 27.7505L7.02539 26.7748C7.02539 26.7748 9.65626 20.9782 9.65626 20.83C9.65626 20.6818 9.54785 15.8357 10.3393 13.765C11.0151 11.9942 14.188 5.38447 23.0528 5.63021C28.7048 5.62298 33.9665 10.3065 34.7833 15.908C34.9748 17.9534 35.6687 21.7046 32.3584 26.0881C31.9103 26.8543 31.6754 27.7252 31.6754 28.6106V36.3659",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1038 14.4262C20.1038 14.4262 20.9566 13.0132 22.3696 13.0638C23.7826 13.1144 24.4404 14.4515 23.9525 15.8393",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6877 17.6174C22.6877 17.6174 22.9082 19.0051 24.7838 18.81C25.6113 18.7233 26.4389 18.127 26.5618 16.0093",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0259 19.0305C25.0259 19.0305 26.5618 23.2334 29.8829 20.9712C29.9985 20.8917 30.0997 20.7941 30.1828 20.6784C30.6635 20.0352 31.8452 18.4198 29.8937 16.6924",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9216 17.4186C28.9216 17.4186 31.2091 15.3984 29.6263 12.941C28.0434 10.48 25.3909 12.0159 25.3909 12.0159",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1705 12.9412C25.1705 12.9412 25.7812 9.1647 21.8566 8.89728C20.2376 8.78525 19.2691 9.62727 18.7053 10.4657C18.2319 11.1668 17.9934 12.0016 17.9428 12.8472L17.8633 14.1337",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5453 12.7457C17.5453 12.7457 14.4266 12.3699 13.8918 15.5464C13.234 19.4421 17.5453 20.0023 17.5453 20.0023",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.104 17.2524C20.104 17.2524 17.8128 18.0077 17.8634 19.8327C17.8634 19.8508 17.8634 19.8689 17.8634 19.8869C17.9212 21.1698 19.0993 22.1094 20.375 21.9721C21.2568 21.8782 22.5758 21.7878 22.7818 22.0733C22.7818 22.0733 23.6347 22.5612 23.6347 23.4357V26.9195",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydataIcon);
export default __webpack_public_path__ + "static/media/MydataIcon.72bc31f0091c9afc19d10c3c42eca6b1.svg";
export { ForwardRef as ReactComponent };